import React from 'react'

import { IconNoPermission } from '@avantstay/backoffice-vectors'

import { EmptySearch } from '@new/__global/components/EmptySearch'

export const DefaultPermissionsFallback = () => (
  <EmptySearch
    icon={<IconNoPermission />}
    title="You do not have sufficient privileges to access this page."
    description="If you need access, reach out to your manager for assistance."
  />
)
